import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../instance";

const initialState = {
  saving: false,
};

export const save = createAsyncThunk(
  "saveSlice/save/ordinary",
  async (data, { rejectWithValue }) => {
    let saveUrl = data.url;
    delete data.url;
    await new Promise((resolve) => setTimeout(resolve, 0));
    try {
      const response = await axiosInstance.post(`/${saveUrl}`, data);
      if (!response.data.success) {
        return rejectWithValue(response.data);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const saveArray = createAsyncThunk(
  "saveSlice/saveArray/ordinary",
  async (data, { rejectWithValue }) => {
    let saveUrl = data.url;
    delete data.url;
    await new Promise((resolve) => setTimeout(resolve, 0));
    const payloadToSend = Array.isArray(data.data) ? data.data : data.data;

    try {
      const isFormEncoded = typeof payloadToSend === "string";

      const response = await axiosInstance.post(
        `/${saveUrl}`,
        payloadToSend,
        {
          headers: {
            "Content-Type": isFormEncoded
              ? "application/x-www-form-urlencoded"
              : "application/json",
          },
        }
      );

      if (!response.data.success) {
        return rejectWithValue(response.data);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data ?? error.message);
    }
  }
);
export const saveFileUpload = createAsyncThunk(
  "saveSlice/save/saveFileUpload",
  async ({ url, formData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (!response.data.success) {
        return rejectWithValue(response.data);
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const saveSlice = createSlice({
  name: "save",
  initialState,
  reducers: {
    clearSaveObj: () => {
      return { ...initialState };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(save.pending, (state) => {
        state.saving = true;
      })
      .addCase(save.fulfilled, (state) => {
        state.saving = false;
      })
      .addCase(save.rejected, (state) => {
        state.saving = false;
      })

      .addCase(saveArray.pending, (state) => {
        state.saving = true;
      })
      .addCase(saveArray.fulfilled, (state) => {
        state.saving = false;
      })
      .addCase(saveArray.rejected, (state) => {
        state.saving = false;
      })

      .addCase(saveFileUpload.pending, (state) => {
        state.saving = true;
      })
      .addCase(saveFileUpload.fulfilled, (state, action) => {
        state.saving = false;
      })
      .addCase(saveFileUpload.rejected, (state) => {
        state.saving = false;
      });
  },
});

export default saveSlice.reducer;
export const { clearSaveObj } = saveSlice.actions;
